import { FacilitiesService } from "@common/client"
import { locationsBaseKey } from "./locations"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "./utils"

export const facilitiesBaseKey = ["facilities"] as const

export const facilitiesQuery = makeNoArgsQuery({
  serviceCall: FacilitiesService.listFacilities,
  queryKey: facilitiesBaseKey,
})

export const useCreateFacilityMutation = makeAxiosMutation({
  serviceCall: FacilitiesService.create,
  invalidates: () => [facilitiesBaseKey, locationsBaseKey],
})

export const useUpdateFacilityMutation = makeAxiosMutation({
  serviceCall: FacilitiesService.update,
  invalidates: () => [facilitiesBaseKey, locationsBaseKey],
})

export const useDeleteFacilityMutation = makeAxiosMutation({
  serviceCall: FacilitiesService.delete,
  invalidates: () => [facilitiesBaseKey, locationsBaseKey],
})

export const archivedFacilitiesQuery = makeNoArgsQuery({
  serviceCall: () => FacilitiesService.listFacilities({ deleted: true }),
  queryKey: [...facilitiesBaseKey, "archived"],
})

export const facilityQuery = makeQuery({
  serviceCall: (id: string) =>
    FacilitiesService.get({ facility_id: id, include_archived: true }),
  queryKey: (id) => [...facilitiesBaseKey, "detail", id],
})

export const useRestoreFacilityMutation = makeAxiosMutation({
  serviceCall: FacilitiesService.restore,
  invalidates: () => [facilitiesBaseKey, locationsBaseKey],
})
